"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f119 = void 0;
exports.f119 = {
    "wa": [
        "Latn"
    ],
    "waa": [
        "Latn"
    ],
    "wab": [
        "Latn"
    ],
    "wac": [
        "Latn"
    ],
    "wad": [
        "Latn"
    ],
    "wae": [
        "Latn"
    ],
    "waf": [
        "Latn"
    ],
    "wag": [
        "Latn"
    ],
    "wah": [
        "Latn"
    ],
    "wai": [
        "Latn"
    ],
    "waj": [
        "Latn"
    ],
    "wal": [
        "Ethi",
        "Latn"
    ],
    "wam": [
        "Latn"
    ],
    "wan": [
        "Latn"
    ],
    "wao": [
        "Zyyy"
    ],
    "wap": [
        "Latn"
    ],
    "waq": [
        "Latn"
    ],
    "war": [
        "Latn",
        "Brai"
    ],
    "was": [
        "Latn"
    ],
    "wat": [
        "Latn"
    ],
    "wau": [
        "Latn"
    ],
    "wav": [
        "Latn"
    ],
    "waw": [
        "Latn"
    ],
    "wax": [
        "Latn"
    ],
    "way": [
        "Latn"
    ],
    "waz": [
        "Latn"
    ],
    "wba": [
        "Latn"
    ],
    "wbb": [
        "Latn"
    ],
    "wbe": [
        "Latn"
    ],
    "wbf": [
        "Latn"
    ],
    "wbh": [
        "Latn"
    ],
    "wbi": [
        "Latn"
    ],
    "wbj": [
        "Latn"
    ],
    "wbk": [
        "Arab"
    ],
    "wbl": [
        "Latn",
        "Arab",
        "Cyrl"
    ],
    "wbm": [
        "Latn"
    ],
    "wbp": [
        "Latn"
    ],
    "wbq": [
        "Telu"
    ],
    "wbr": [
        "Deva"
    ],
    "wbs": [
        "Zxxx"
    ],
    "wbt": [
        "Latn"
    ],
    "wbv": [
        "Latn"
    ],
    "wbw": [
        "Latn"
    ],
    "wca": [
        "Latn"
    ],
    "wci": [
        "Latn"
    ],
    "wdd": [
        "Latn"
    ],
    "wdg": [
        "Latn"
    ],
    "wdj": [
        "Latn"
    ],
    "wdk": [
        "Latn"
    ],
    "wdu": [
        "Latn"
    ],
    "wdy": [
        "Latn"
    ],
    "wea": [
        "Zyyy"
    ],
    "wec": [
        "Latn"
    ],
    "wed": [
        "Latn"
    ],
    "weg": [
        "Latn"
    ],
    "weh": [
        "Latn"
    ],
    "wei": [
        "Latn"
    ],
    "wem": [
        "Latn"
    ],
    "weo": [
        "Latn"
    ],
    "wep": [
        "Latn"
    ],
    "wer": [
        "Latn"
    ],
    "wes": [
        "Latn"
    ],
    "wet": [
        "Latn"
    ],
    "weu": [
        "Latn"
    ],
    "wew": [
        "Latn"
    ],
    "wfg": [
        "Latn"
    ],
    "wga": [
        "Latn"
    ],
    "wgb": [
        "Latn"
    ],
    "wgg": [
        "Latn"
    ],
    "wgi": [
        "Latn"
    ],
    "wgo": [
        "Latn"
    ],
    "wgu": [
        "Latn"
    ],
    "wgy": [
        "Latn"
    ],
    "wha": [
        "Latn"
    ],
    "whg": [
        "Latn"
    ],
    "whk": [
        "Latn"
    ],
    "whu": [
        "Latn"
    ],
    "wib": [
        "Latn"
    ],
    "wic": [
        "Latn"
    ],
    "wie": [
        "Latn"
    ],
    "wif": [
        "Latn"
    ],
    "wig": [
        "Latn"
    ],
    "wih": [
        "Latn"
    ],
    "wii": [
        "Latn"
    ],
    "wij": [
        "Latn"
    ],
    "wik": [
        "Latn"
    ],
    "wil": [
        "Latn"
    ],
    "wim": [
        "Latn"
    ],
    "win": [
        "Latn"
    ],
    "wir": [
        "Latn"
    ],
    "wiu": [
        "Latn"
    ],
    "wiv": [
        "Latn"
    ],
    "wiy": [
        "Latn"
    ],
    "wja": [
        "Latn"
    ],
    "wji": [
        "Latn"
    ],
    "wka": [
        "Latn"
    ],
    "wkb": [
        "Zyyy"
    ],
    "wkd": [
        "Latn"
    ],
    "wkl": [
        "Zyyy"
    ],
    "wkr": [
        "Latn"
    ],
    "wku": [
        "Zyyy"
    ],
    "wkw": [
        "Latn"
    ],
    "wky": [
        "Latn"
    ],
    "wla": [
        "Latn"
    ],
    "wlc": [
        "Zyyy"
    ],
    "wle": [
        "Arab"
    ],
    "wlg": [
        "Latn"
    ],
    "wlh": [
        "Latn"
    ],
    "wli": [
        "Latn"
    ],
    "wlk": [
        "Zyyy"
    ],
    "wll": [
        "Zyyy"
    ],
    "wlm": [
        "Latn"
    ],
    "wlo": [
        "Arab"
    ],
    "wlr": [
        "Latn"
    ],
    "wls": [
        "Latn"
    ],
    "wlu": [
        "Latn"
    ],
    "wlv": [
        "Latn"
    ],
    "wlw": [
        "Latn"
    ],
    "wlx": [
        "Latn"
    ],
    "wly": [
        "Zyyy"
    ],
    "wma": [
        "Latn"
    ],
    "wmb": [
        "Latn"
    ],
    "wmc": [
        "Latn"
    ],
    "wmd": [
        "Latn"
    ],
    "wme": [
        "Deva"
    ],
    "wmg": [
        "Zyyy"
    ],
    "wmh": [
        "Latn"
    ],
    "wmi": [
        "Latn"
    ],
    "wmm": [
        "Latn"
    ],
    "wmn": [
        "Latn"
    ],
    "wmo": [
        "Latn"
    ],
    "wms": [
        "Latn"
    ],
    "wmt": [
        "Latn"
    ],
    "wmw": [
        "Latn",
        "Arab"
    ],
    "wmx": [
        "Latn"
    ],
    "wnb": [
        "Latn"
    ],
    "wnc": [
        "Latn"
    ],
    "wnd": [
        "Latn"
    ],
    "wne": [
        "Arab"
    ],
    "wng": [
        "Latn"
    ],
    "wni": [
        "Arab",
        "Latn"
    ],
    "wnk": [
        "Latn"
    ],
    "wnm": [
        "Latn"
    ],
    "wnn": [
        "Latn"
    ],
    "wno": [
        "Latn"
    ],
    "wnp": [
        "Latn"
    ],
    "wnu": [
        "Latn"
    ],
    "wnw": [
        "Latn"
    ],
    "wny": [
        "Latn"
    ],
    "wo": [
        "Latn",
        "Arab"
    ],
    "woa": [
        "Latn"
    ],
    "wob": [
        "Latn"
    ],
    "woc": [
        "Latn"
    ],
    "wod": [
        "Latn"
    ],
    "woe": [
        "Latn",
        "Wole"
    ],
    "wof": [
        "Latn",
        "Arab"
    ],
    "wog": [
        "Latn"
    ],
    "woi": [
        "Latn"
    ],
    "wok": [
        "Latn"
    ],
    "wom": [
        "Latn"
    ],
    "won": [
        "Latn"
    ],
    "woo": [
        "Latn"
    ],
    "wor": [
        "Latn"
    ],
    "wos": [
        "Latn"
    ],
    "wow": [
        "Latn"
    ],
    "woy": [
        "Zyyy"
    ],
    "wpc": [
        "Latn"
    ],
    "wrb": [
        "Latn"
    ],
    "wrd": [
        "Arab"
    ],
    "wrg": [
        "Latn"
    ],
    "wrh": [
        "Latn"
    ],
    "wri": [
        "Latn"
    ],
    "wrk": [
        "Latn"
    ],
    "wrl": [
        "Latn"
    ],
    "wrm": [
        "Latn"
    ],
    "wrn": [
        "Zyyy"
    ],
    "wro": [
        "Latn"
    ],
    "wrp": [
        "Latn"
    ],
    "wrr": [
        "Latn"
    ],
    "wrs": [
        "Latn"
    ],
    "wru": [
        "Latn"
    ],
    "wrv": [
        "Latn"
    ],
    "wrw": [
        "Latn"
    ],
    "wrx": [
        "Latn"
    ],
    "wry": [
        "Zyyy"
    ],
    "wrz": [
        "Latn"
    ],
    "wsa": [
        "Latn"
    ],
    "wsg": [
        "Telu",
        "Deva",
        "Gong",
        "Gonm"
    ],
    "wsi": [
        "Latn"
    ],
    "wsk": [
        "Latn"
    ],
    "wsr": [
        "Latn"
    ],
    "wss": [
        "Latn"
    ],
    "wsu": [
        "Latn"
    ],
    "wsv": [
        "Arab"
    ],
    "wtf": [
        "Latn"
    ],
    "wth": [
        "Latn"
    ],
    "wti": [
        "Latn"
    ],
    "wtk": [
        "Latn"
    ],
    "wtm": [
        "Deva"
    ],
    "wtw": [
        "Latn",
        "Bugi"
    ],
    "wua": [
        "Latn"
    ],
    "wub": [
        "Latn"
    ],
    "wud": [
        "Latn"
    ],
    "wuh": [
        "Zyyy"
    ],
    "wul": [
        "Latn"
    ],
    "wum": [
        "Latn"
    ],
    "wun": [
        "Latn"
    ],
    "wur": [
        "Latn"
    ],
    "wut": [
        "Latn"
    ],
    "wuu": [
        "Hans",
        "Hant",
        "Latn"
    ],
    "wuv": [
        "Latn"
    ],
    "wux": [
        "Latn"
    ],
    "wuy": [
        "Latn"
    ],
    "wwa": [
        "Latn"
    ],
    "wwb": [
        "Latn"
    ],
    "wwo": [
        "Latn"
    ],
    "wwr": [
        "Latn"
    ],
    "www": [
        "Latn"
    ],
    "wxa": [
        "Zyyy"
    ],
    "wxw": [
        "Latn"
    ],
    "wya": [
        "Latn"
    ],
    "wyb": [
        "Latn"
    ],
    "wyi": [
        "Latn"
    ],
    "wym": [
        "Latn"
    ],
    "wyr": [
        "Latn"
    ],
    "wyy": [
        "Latn"
    ]
};
